/* eslint-disable react/prop-types */
import "./ShowUserInfo.css";
import React from "react";
// import { Store } from "../Store/store";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
// import { API_URL, unescapeHTML, custom_axios, custom_axios_post, kbnOptions } from "./Common";
import Slide from "@mui/material/Slide";
import styled from "@emotion/styled";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const StyledDialogContent = styled(DialogContent)`
  padding: 0px;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-right: 20px;
`;
const StyledDialogTitle = styled(DialogTitle)`
  color: ${(props) => props.theme.palette.primary.contrastText};
  background-color: ${(props) => props.theme.palette.primary.main};
  padding: 5px 10px;
`;
const StyledButton = styled(Button)`
  color: ${(props) => props.theme.palette.primary.contrastText};
  background-color: ${(props) => props.theme.palette.primary.main};
`;
const StyledMarginDiv = styled("div")`
  margin-right: 50px;
`;
const StyledFlexDiv = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px;
`;

function ShowSearch({ open, honbuid, handleClose }) {
  console.log("honbuid", honbuid);
  return (
    <Dialog open={open} onClose={() => handleClose()} fullWidth maxWidth={"md"} TransitionComponent={Transition}>
      <StyledDialogTitle id="max-width-dialog-title">
        <div className="show-member-search">
          <StyledMarginDiv>ログ検索</StyledMarginDiv>
          <div className="question-title-actions">
            <StyledButton onClick={() => handleClose()} variant="outlined">
              閉じる (Esc)
            </StyledButton>
          </div>
        </div>
      </StyledDialogTitle>

      <StyledDialogContent>
        <StyledFlexDiv></StyledFlexDiv>
      </StyledDialogContent>
    </Dialog>
  );
}

export default ShowSearch;
